import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, API_NAME} from './constants';


class SestavyApi extends BaseApi {
	constructor() {
		super(DMS_MODULE, API_NAME);
	}
	async GetItemsReceivedDetailReport(parameter: any, languageId: any, columnsSeq: any) {
		return this.downloadXlsxReport(`/${DMS_MODULE}/${API_NAME}/GetItemsReceivedDetailReport?${parameter}&LanguageId=${languageId}&ColumnSequence=${columnsSeq}`, 'ItemsReceivedDetail.xlsx');
	}
}

export const apiProvider = new SestavyApi();
